export type SupportedTypeUpload =
  | 'application/pdf'
  | 'image/jpeg'
  | 'image/png'
  | 'image/webp'

export const SUPPORTED_UPLOAD_TYPES: readonly SupportedTypeUpload[] = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp'
] as const
